export default __webpack_public_path__ + "static/media/Rissois-De-Camarao.f07e8df4.jpg";